<template>
  <div>
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/rum">Alla rum</router-link>
        <router-link tag="li" to="/rum/ny">Skapa ett nytt rum</router-link>
      </ul>
      <div class="clear"></div>
    </div>

    <div class="bootstrap-wrapper" v-if="columnSet && rooms.length">
      <div class="container">
        <div class="row">

            <div v-for="room in rooms" :class="columnClass" style="padding:0px;">
              <div class="room">

                <div style="position:absolute;top:0px;height:100px;width:100%;z-index:100;">
                  <div style="color:#FFF;text-align:right;padding:12px;padding-top:4px;" v-if="(room.id in roomEvents)">
                    <transition-group name="fade">
                      <div v-for="item in roomEvents[room.id].slice().reverse().slice(0,6)" v-if="!item.removed" :key="item.key">
                          <div style="font-size:11px;">{{ item.time | moment("calendar") }}</div>
                          <div v-if="$root.capabilities[item.capability].type === 'boolean'">
                            <strong>{{ item.node.name }}</strong> – ({{ $root.capabilities[item.capability].name }}): {{ $root.capabilities[item.capability].values[item.value].name }}
                          </div>
                          <div v-if="$root.capabilities[item.capability].type === 'number'">
                            <strong>{{ item.node.name }}</strong> – ({{ $root.capabilities[item.capability].name }}): {{ item.value }}{{ $root.capabilities[item.capability].unit }}
                          </div>
                      </div>
                    </transition-group>
                  </div>
                </div>
                
                <div class="roomOptions">
                  <div style="font-size:30px;margin-bottom:-3px;">{{ room.name }}</div>
                  
                  <div style="font-size:13px;" class="details">
                    <span>Total {{ nodesForRoom(room.id).length }} enheter </span>
                    <span v-if="nodesForRoom(room.id, 'switchBinary', true).length">varav {{ nodesForRoom(room.id, 'switchBinary', true).length }} är på</span>
                    <span v-else>och alla enheter är avstängda</span>
  
                    <span v-if="nodesForRoom(room.id, 'notificationMotion').length">
                      <span>&#8226;</span>
                      <span v-if="nodesForRoom(room.id, 'notificationMotion', true).length">{{ nodesForRoom(room.id, 'notificationMotion', true).length }} detekterar rörelse</span>
                      <span v-else>Ingen rörelse</span>
                    </span>
                    
                    <span v-if="nodesForRoom(room.id, 'notificationContact').length">
                      <span>&#8226;</span>
                      <span v-if="nodesForRoom(room.id, 'notificationContact', true).length">{{ nodesForRoom(room.id, 'notificationContact', true).length }} magnetkontakter är öppnade</span>
                      <span v-else>Inga magnetkontakter öppnade</span>
                    </span>
                    
                    <span v-if="avgForRoomAndCapability(room.id, 'temperature')">
                      <span>&#8226;</span>
                      <span>medeltemperatur är {{ avgForRoomAndCapability(room.id, 'temperature') }}°C</span>
                    </span>
                  </div>
                  
                  <div style="margin-top:8px;">
                    <button @click="details(room.id)" style="background:none;color:#FFF;width:100px;">Visa detaljer</button>
                    <button v-if="nodesForRoom(room.id).length" @click="cmd(room.id, 'on')" style="background:none;color:#FFF;width:90px;">Tänd alla</button>
                    <button v-if="nodesForRoom(room.id).length" @click="cmd(room.id, 'off')" style="background:none;color:#FFF;width:90px;">Släck alla</button>
                  </div>      
                         
                </div>
                
                <img :src="room.backURL" style="width:100%;height:100%;object-fit:cover;">
              </div>
            </div>
          </div>
        </div>
      
      <!--<div class="descr" v-if="!hasColumnSettings" style="margin-top:10px;"><strong>Psst!</strong> Du kan trycka C på tangentbordet för att ändra storleken på rummen.</div>-->
    </div>
    <div v-else>
      <info-view>
        <img src="../assets/nexa/rum_svart.png" style="margin-bottom:1em;">
        <h3>Inga rum tillagda</h3>
        <div>Här kommer du se alla dina rum, däremot verkar det inte som om du har några just nu, vilket är lite synd.</div>
      </info-view>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { eventbus } from '../eventbus.js'
  import infoView from './views/infoView'

  export default {
    name: 'rum',
    components: {
      infoView
    },
    data () {
      return {
        column: 4,
        columnSet: false,
        roomEvents: {}
      }
    },
    created () {
      eventbus.$on('nodeEvent', (json) => {
        const node = this.$root.data.nodes.find(node => node.id === json.sourceNode)
        if (node && node.roomId !== 0) {
          let array = (this.roomEvents[node.roomId] ? this.roomEvents[node.roomId] : [])

          const t = array.push({
            node: node,
            value: json.value,
            capability: json.name,
            time: new Date(),
            key: Math.floor((Math.random() * 100000) + 1),
            removed: false
          })

          this.$set(this.roomEvents, node.roomId, array)
          
          
          setTimeout(() => {
            this.roomEvents[node.roomId][(t - 1)].removed = true
          }, 4000)
          
        }
      })

      
      if (this.hasColumnSettings) {
        this.column = this.$root.data.usersettings.web.roomColumn
        this.columnSet = true
      } else {
        this.columnSet = true
      }

      // Kör det möjligt att genom trycka C (just nu) ändra storleken
      // på rummen. Detta i sig resulterar i ett HTTP-anrop till Bridgen
      // som sparar storleken så det är samma storlek nästa gång användaren
      // kommer tillbaka.
      window.addEventListener('keydown', (event) => {
        if (event.keyCode == 67) {
          this.changeSize()
        }
      })

      /**
        Eftersom det inte finns tangenter på smarta enheter kan användaren inte byta
        storlek på rummen. Här nedanför gör vi det möjligt att byta storleken på rummmen
        genom att skaka telefonen eller iPaden.
      */
      if (typeof window.DeviceMotionEvent != 'undefined') {
        var sensitivity = 20;
        var x1 = 0, y1 = 0, z1 = 0, x2 = 0, y2 = 0, z2 = 0;
    
        // Listen to motion events and update the position
        window.addEventListener('devicemotion', function (e) {
            x1 = e.accelerationIncludingGravity.x;
            y1 = e.accelerationIncludingGravity.y;
            z1 = e.accelerationIncludingGravity.z;
        }, false);
    
        setInterval(function () {
            var change = Math.abs(x1-x2+y1-y2+z1-z2);
    
            if (change > sensitivity) {
              this.changeSize()
            }    

            x2 = x1;
            y2 = y1;
            z2 = z1;
        }, 150);
      }
    },
    methods: {
      changeSize () {
        if (this.column === 4) {
          this.column = 6
        } else if (this.column == 6) {
          this.column = 12
        } else {
          this.column = 4
        }
        
        this.columnTipSeen = true

        if (!('web' in this.$root.data.usersettings)) {
          this.$root.data.usersettings.web = {}
        }

        this.$root.data.usersettings.web.roomColumn = this.column
        
        HTTP.post('usersettings', this.$root.data.usersettings)
      },
      
      getNodesInRoom (roomId) {
        return this.$root.data.nodes.filter(node => node.roomId === roomId)
      },
      
      remove (id) {
        const index = this.$root.data.rooms.findIndex(room => room.id === id)
        this.$root.data.rooms.splice(index, 1)

        HTTP.delete('rooms/' + id)
      },

      details (id) {
        //this.open = (this.open === id ? null : id)
        this.$router.push({
          name: 'rum_detaljer',
          params: {
            id: id
          }
        })
      },
      
      clear () {
        alert('s')
      },

      action (room, method) {
        HTTP.post('rooms/' + room.id + '/' + method)
        .then(res => res.data)
        .then(json => {

        })
      },

      add () {
        this.$router.push({
          name: 'rum_ny'
        })
      },
      
      // För att tända och släcka ett rum
      cmd (roomId, method) {
        HTTP.post('rooms/' + roomId + '/' + method)
        .then(res => res.data)
        .then(json => {
          // Klart
        })
      },
      
      nodesForRoom (roomId, capability, hasValue) {
        
        return this.$root.data.nodes.filter(node => {
          let returned = false
          
          if (node.roomId !== roomId) {
            return false
          }
          
          if (node.hideInApp) {
            return false
          }
          
          if (capability) {
            if (!node.capabilities.includes(capability)) {
              return false
            }
            
            if (hasValue !==undefined && capability in node.lastEvents && 'value' in node.lastEvents[capability]) {
              if (node.lastEvents[capability].value !== hasValue) {
                return false
              }
            }
          }
          
          return true
        })
      },
      
      /**
        Räknar ut ett medelvärde för den tillhandahållna capabilityn.
      */
      avgForRoomAndCapability (roomId, capability) {
        // Hämta ut noderna
        const nodes = this.$root.data.nodes.filter(node => (node.roomId === roomId && node.capabilities.includes(capability) && capability in node.lastEvents))
        
        // Kolla så vi har några noder som vi kan returnera
        if (nodes.length > 0) {
          let total = 0
          nodes.forEach(node => total = (total + node.lastEvents[capability].value))
          
          // Returnera datan
          return parseFloat(total / nodes.length).toFixed(1)
        }
        
        return null
      }
    },
    
    computed: {
      rooms () {
        return this.$root.data.rooms.filter(room => {
          if (room.id.toString() === '0') return false
          if (room.id.toString() === '-1') return false

          return true
        })
      },

      columnClass () {
        //return 'col-md-' + this.column
        return 'col-md-12'
      },

      hasColumnSettings () {
        return ('web' in this.$root.data.usersettings && 'roomColumn' in this.$root.data.usersettings.web)
      }
    },
    
    // Återställ lite grejer när vyn försvinner för oss.
    destroyed() {
      eventbus.$off('nodeEvent')
      this.roomEvents = {}
    }
  }
</script>

<style scoped>
  .room {
    box-shadow: 0px 19px 38px rgba(0, 0, 0, 0.53);
    height:200px;
    text-shadow: 1px 1px 1px black;
    margin-bottom:20px;
    box-sizing: border-box;
  }

  .pointer {
    cursor: pointer;
  }
  
  
</style>


// WEBPACK FOOTER //
// src/components/rum.vue